import { EnabledIconProps, IconProps } from './IconProps';

export const OvalIcon = ({
  className,
  height = 3,
  width = 3,
  enabled = false,
}: IconProps & EnabledIconProps) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 3 3"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="42.5"
      cy="62.5"
      r="1.5"
      transform="translate(-41 -61)"
      fill={enabled ? '#2396FD' : '#B2B2B2'}
      fillRule="evenodd"
    />
  </svg>
);
